import styled from 'styled-components';
import { Styling } from '../../../../constants';

export const SeasonSelectClass = 'SeasonSelector';

export const SeasonSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  text-align: center;
  .${SeasonSelectClass} {
    width: 160px;
  }
`;
